module.exports = __webpack_public_path__ + "img/photo-0076.401a7f89.jpg";